import { render, staticRenderFns } from "./Zgodovina.vue?vue&type=template&id=2493a91a&scoped=true"
import script from "./Zgodovina.vue?vue&type=script&lang=js"
export * from "./Zgodovina.vue?vue&type=script&lang=js"
import style0 from "./Zgodovina.vue?vue&type=style&index=0&id=2493a91a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2493a91a",
  null
  
)

export default component.exports